import { memo, useCallback, useRef, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons/faInfoCircle';
import { Tabs } from 'react-aria-components';
import { DetailTabsEnum } from '@pages/orders/detail/tabs-menu/DetailTabsEnum';
import { TabList } from '@pages/orders/detail/tabs-menu/TabList';
import { TabPanel } from '@pages/orders/detail/tabs-menu/TabPanel';
import { selectSelectedItemCustomerInfo } from '@pages/orders/store/selectors';
import { BasicOverview } from '@pages/orders/detail/tabs-pages/basic-overview/BasicOverview';
import { CustomerInfo } from '@pages/orders/detail/tabs-pages/customer-info/CustomerInfo';
import { OrderTimeline } from '@pages/orders/detail/tabs-pages/order-timeline/OrderTimeline';



interface DetailProps {
	dateWithoutTime: string,
	isSmallScreen: boolean,
	ordersScrollTop?: number,
	ordersTop?: number,
	ordersHeight?: number,
}


export const Detail = (props: DetailProps) => {
	const { dateWithoutTime, isSmallScreen, ordersScrollTop, ordersTop, ordersHeight } = props;

	const customerInfo = useSelector(selectSelectedItemCustomerInfo);
	const stickyRef = useRef<HTMLDivElement>(null);
	const [ maxHeight, setMaxHeight ] = useState<number | null>(null);

	const selectedOrderUnvId = customerInfo ? customerInfo.selectedOrderUnvId : '';


	useEffect(() => {
		if (ordersScrollTop !== undefined && ordersScrollTop !== null) {
			computeMaxHeight();
		}
	}, [ ordersScrollTop, customerInfo ]);


	const computeMaxHeight = useCallback(() => {
		if (!stickyRef || !stickyRef.current) return;
		if (ordersTop === undefined || ordersTop === null) return;
		if (ordersHeight === undefined || ordersHeight === null) return;

		let rect = stickyRef.current.getBoundingClientRect();
		let heightAbove = rect.top - 8 - ordersTop;
		let remainingVisibleHeight = ordersHeight - heightAbove - 20;
		setMaxHeight(remainingVisibleHeight);
	},[ stickyRef, ordersTop, ordersHeight ]);


	if (!customerInfo) return (
		<div className='detail-area'>
			<div className='detail-area-sticky' ref={stickyRef} style={maxHeight ? { maxHeight } : undefined}>
				
				<div className='detail-area-header'>
					<FontAwesomeIcon className='detail-area-header-icon' icon={faInfoCircle} />
					<p className='detail-area-header-label'>Detail</p>
				</div>

				<p className='detail-area-empty'>Není vybraná žádná objednávka</p>

			</div>
		</div>
	);


	return (
		<div className='detail-area'>
			<Tabs
				className='react-aria-Tabs detail-area-sticky'
				ref={stickyRef}
				style={maxHeight ? { maxHeight } : {}}
				defaultSelectedKey={DetailTabsEnum.basicOverview}
			>
				
				<div className='detail-area-header'>
					<FontAwesomeIcon className='detail-area-header-icon' icon={faInfoCircle} />
					<p className='detail-area-header-label'>{`Detail - ${customerInfo.customerName}`}</p>
					<TabList />
				</div>

				<TabPanel selectedOrderUnvId={selectedOrderUnvId} id={DetailTabsEnum.basicOverview} className='detail-basic-overview'>
					<BasicOverview
						destinationUnvId={customerInfo.destinationUnvId}
						selectedOrderUnvId={customerInfo.selectedOrderUnvId}
						selectedOrderDateWithoutTime={customerInfo.selectedOrderDateWithoutTime
							? customerInfo.selectedOrderDateWithoutTime
							: dateWithoutTime}
						isSmallScreen={isSmallScreen}
					/>
				</TabPanel>

				<TabPanel selectedOrderUnvId={selectedOrderUnvId} id={DetailTabsEnum.customerInfo} className='detail-customer-info'>
					<CustomerInfo destinationSystemId={customerInfo.destinationId} />
				</TabPanel>

				<TabPanel selectedOrderUnvId={selectedOrderUnvId} id={DetailTabsEnum.orderTimeline} className='detail-order-timeline'>
					<OrderTimeline orderUnvId={customerInfo.orderUnvId} />
				</TabPanel>

			</Tabs>
		</div>
	)
}

export default memo(Detail);